import React from 'react';
import { getRandomHeadshot, getHeadshotPath } from './utils';

/**
 * About section component with headshot and bio
 */
const AboutSection = () => {
  const headshotNumber = getRandomHeadshot();

  return (
    <section id="about" className="py-16 bg-gray-50">
      <div className="container mx-auto px-6">
        <div className="md:flex md:items-center">
          <div className="md:w-1/2 mb-10 md:mb-0">
            <img 
              src={getHeadshotPath(headshotNumber)} 
              alt="Tudor Emanuel" 
              className="rounded-lg shadow-xl max-w-md mx-auto"
            />
          </div>
          <div className="md:w-1/2 md:pl-12">
            <h2 className="text-3xl md:text-4xl font-bold mb-6">About Tudor Emanuel</h2>
            <p className="text-lg text-gray-700 mb-6">
              For over 15 years, I've helped individuals and organizations achieve extraordinary results through strategic coaching, immersive events, and transformative programs.
            </p>
            <p className="text-lg text-gray-700 mb-6">
              My approach combines cutting-edge strategies, practical tools, and deep psychological insights that create lasting change in both personal and professional domains.
            </p>
            <button className="bg-blue-800 hover:bg-blue-900 text-white font-bold py-3 px-8 rounded-lg transition shadow-lg">
              Learn More About My Journey
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;